import Button from "@material-ui/core/Button";
import React from "react";
import { Link, Redirect } from "react-router-dom";
import Page from "src/shared/components/Page";
import SmartTable from "src/shared/components/SmartTable";
import { ITemplate } from "src/api/types";
import { withSchoolContext } from "../../DirectorPage";
import IDirectorPageProps from "../IDirectorPageProps";
import { SURVEY_PAGE_HEADER, SURVEY_PAGE_SUBTITLE } from "./constants";

export default withSchoolContext(
  class extends React.Component<IDirectorPageProps, {}> {
    private tableHeaders = [
      {
        id: "id",
        label: "Survey Name",
        orderBy: (item: ITemplate) => item.id as any,
        render: (item: ITemplate) => <span>{item.name}</span>,
      },
      {
        id: "state",
        label: "",
        notSearchable: true,
        render: (item: ITemplate) => (

          <div className="view-survey">
          <Button
            variant="contained"
            color="primary"
            component={Link}
            {...({ to: `survey/edit/${item.id}` } as any)}
          >
            View Survey
          </Button>
          </div>
        ),
      },
    ];

    public render() {
      const templates = this.props.school.templates;

      return (
        <Page header={SURVEY_PAGE_HEADER} subtitle={SURVEY_PAGE_SUBTITLE}>
          {templates.length > 1 && (
            <SmartTable
              tableHeaders={this.tableHeaders}
              default={{ order: "asc", orderBy: "id" }}
              tableRows={templates}
              filterable={false}
              sortable={true}
              searchable={false}
              showSearchNumbers={true}
            />
          )}
          {templates.length === 1 && (
            <Redirect to={`survey/edit/${templates[0].id}`} />
          )}
        </Page>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/features/director/pages/survey/SurveyPage.tsx